import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import "./MobileOtpPage.css";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import callApi from "../../../../utility/apiCaller";
import { setUserClickData } from "../../../../utility/setUserClickData";
import { login } from "../../../../store/app/appReducer";
import OTPInput from "react-otp-input";
import FormInputStyle2 from "../../../../components/Form/FormInputStyle2";
import FormButtonStyleCheckOffer from "../../../../components/Form/FormButtonStyleCheckOffer";
import moment from "moment";
import { setInternalLead } from "../../../../store/app/aaSlice";
const MobileOtpPage = ({
  isFormStarted,
  setIsFormStarted,
  currentStep,
  setCurrentStep,
  formData,
  setFormData,
}) => {
  const [mobile, setMobile] = useState("");
  const [isMobileValid, setIsMobileValid] = useState(true);
  const [source, setSource] = useState("");
  const [utmSource, setUtmSource] = useState("");
  const [utmMedium, setUtmMedium] = useState("");
  const [affId, setAffId] = useState("");
  const [params] = useSearchParams();
  const [isConsentChecked, setIsConsentChecked] = useState(true); // ✅ default true
  const [isLoading, setIsLoading] = useState(false);
  const [isTncChecked, setIsTncChecked] = useState(true);
  const [isOtpGenerated, setIsOtpGenerated] = useState(false);
  const [otp, setOtp] = useState("");
  const dispatch = useDispatch();
  const [leadId, setLeadId] = useState("");
  const [isEditMobileModalOpen, setIsEditMobileModalOpen] = useState(false);
  const [editMobileValue, setEditMobileValue] = useState("");
  const [editMobileError, setEditMobileError] = useState("");
  const RESEND_OTP_TIME = 30;
  const [resendCounter, setResendCounter] = useState(RESEND_OTP_TIME);
  const [canResendOtp, setCanResendOtp] = useState(false);
  const [otpTimerKey, setOtpTimerKey] = useState(0);
  const [ipAddress, setIpAddress] = useState("");
  const [CuserName, setUserName] = useState("");
  const ldId = params.get("ld_id") || "";

  // ✅ lender_id from params
  const pre_lender_id = params.get("lender_id") || "";

  // Fetch IP
  useEffect(() => {
    const fetchIp = async () => {
      try {
        const res = await fetch("https://api.ipify.org?format=json");
        const data = await res.json();
        setIpAddress(data?.ip);
      } catch (error) {
        console.log("Error fetching IP:", error);
      }
    };
    fetchIp();
  }, []);

  useEffect(() => {
  const fetchUserData = async () => {
    try {
      const res = await callApi(
        `v1/preapproved_lead/${ldId}`,
        "get",
        null,
        "core"
      );
      console.log("Full API response:", res);
      if (res?.data?.preapproved_lead?.contact_name) {
        setUserName(res.data.preapproved_lead.contact_name);
      }
    } catch (err) {
      console.error("Error fetching preapproved lead:", err);
    }
  };

  fetchUserData();
  }, []);

  // OTP Timer
  useEffect(() => {
    if (!isOtpGenerated) return;

    setResendCounter(RESEND_OTP_TIME);
    setCanResendOtp(false);

    const interval = setInterval(() => {
      setResendCounter((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          setCanResendOtp(true);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [isOtpGenerated, otpTimerKey]);

  // URL Params
  useEffect(() => {
    if (params.get("source")) setSource(params.get("source"));
    if (params.get("utm_source")) setUtmSource(params.get("utm_source"));
    if (params.get("utm_medium")) setUtmMedium(params.get("utm_medium"));
    if (params.get("aff_id")) setAffId(params.get("aff_id"));
    if (params.get("lid")) setLeadId(params.get("lid"));
  }, [params]);

  // Reset OTP
  useEffect(() => {
    const container = document.getElementById("personal-loan-form");
    if (container) {
      container.resetOtpState = () => {
        setIsOtpGenerated(false);
        setOtp("");
      };
    }
  }, []);

  const formatResendTime = (seconds) => {
    const clamped = Math.max(0, Number(seconds) || 0);
    const mm = String(Math.floor(clamped / 60)).padStart(2, "0");
    const ss = String(clamped % 60).padStart(2, "0");
    return `${mm}:${ss}`;
  };

  const handleMobileChange = (event) => {
    const value = event.target.value;
    if (/^\d*$/.test(value)) {
      setMobile(value);
      setFormData((prev) => ({ ...prev, mobile: value }));
    }
    setIsMobileValid(value.length === 10);
  };

  const handleConsentChange = () => {
    setIsConsentChecked((prev) => !prev);
  };

  const handleValidation = () => {
    if (!/^\d{10}$/.test(mobile) || mobile.length !== 10) {
      setIsMobileValid(false);
      return false;
    }
    setIsMobileValid(true);
    return true;
  };

  const generateLead = async (token) => {
    try {
      // -----------------------------
      // 1️⃣ CREATE LEAD (DMI LEAD API)
      // -----------------------------
      const res = await callApi(
        "v1/lead/dmi-lead",
        "post",
        {
          lead: {
            contact_phone: mobile,
            contact_name: CuserName && CuserName.trim() ? CuserName : "N/A",
            steps_completed: 1,
            alliance_id: "knightfintech-pre-lead",
            aff_id: params.get("aff_id") || null,
            utm_source: params.get("utm_source") || null,
            source: params.get("source") || null,
            utm_medium: params.get("utm_medium") || null,
            utm_term: params.get("utm_term") || null,
            ads_name: params.get("ads_name") || null,
            ip_address: ipAddress,
            kyc_consent: isTncChecked,
            kyc_consent_datetime: new Date().toISOString(),
          },
        },
        "core",
        token,
      );

      // -----------------------------
      // 2️⃣ VALIDATE RESPONSE
      // -----------------------------
      if (!res || res.status !== "Success") {
        console.error("DMI Lead API failed:", res);
        toast.error("Unable to create lead at the moment.");
        return false;
      }

      const finalLeadId = res?.data?.lead?._id;

      if (!finalLeadId) {
        console.error("Lead ID missing in response:", res);
        toast.error("Lead creation failed due to invalid response.");
        return false;
      }

      // -----------------------------
      // 3️⃣ STORE INTERNAL LEAD ID
      // -----------------------------
      dispatch(setInternalLead(finalLeadId));

      // -----------------------------
      // 4️⃣ ADD LEAD TO CRM SYSTEM
      // -----------------------------

      return finalLeadId; // useful if caller needs it
    } catch (error) {
      // -----------------------------
      // 5️⃣ GLOBAL ERROR CATCH
      // -----------------------------
      console.error("Unexpected error in generateLead:", error);
      toast.error("Something went wrong while generating lead.");
      return false;
    }
  };

  const fetchLeadData = async (token) => {
    try {
      if (leadId) return { hasLead: false, hasOffer: false };

      const startDate = moment()
        .subtract(1, "months")
        .startOf("day")
        .toISOString();
      const endDate = moment().endOf("day").toISOString();

      const response = await callApi(
        "v1/lead/list",
        "post",
        {
          filters: {
            contact_phone: mobile,
            created_at: {
              $gte: startDate,
              $lte: endDate,
            },
          },
        },
        "core",
      );

      const sortedLeads = (response?.data?.leadList || []).sort(
        (a, b) =>
          new Date(b.updatedAt || b.createdAt) -
          new Date(a.updatedAt || a.createdAt),
      );

      const lead = sortedLeads[0];
      let hasLead = false;
      let hasOffer = false;
      let currentLeadId = null;

      if (lead) {
        const { _id, steps_completed } = lead;
        console.log(_id, steps_completed);
        hasLead = true;
        currentLeadId = _id;
      } else {
        // No lead found, start from step 2
        // generateLead(token);
        // setCurrentStep((prev) => prev + 1);
        const newLeadId = await generateLead(token);
        setCurrentStep((prev) => prev + 1);
        return { hasLead: false, hasOffer: false, leadId: newLeadId };
      }
      console.log("Fetched Lead:", lead);
      console.log("going to stpe ", currentStep);
      return { hasLead, hasOffer, leadId: currentLeadId };
    } catch (error) {
      console.error("Failed to fetch lead data:", error);
      return { hasLead: false, hasOffer: false, leadId: null };
    }
  };

  const handleSendOtp = async () => {
    if (!handleValidation()) return;
    if (!isConsentChecked) {
      toast.error("Please agree to the Terms and Conditions.");
      return;
    }

    try {
      setIsLoading(true);
      const response = await callApi(
        "v1/sms/send-otp",
        "post",
        {
          contact_phone: mobile,
          kyc_consent: isConsentChecked,
        },
        "messaging",
      );

      if (response.status === "Success") {
        setUserClickData({
          event_name: `otp-send-for-knightfintech-pre-lead`,
          user_id: mobile || "unknown",
          affiliate_id: affId || "No Aff_id found",
          utm_medium: utmMedium || "",
        });
        setFormData((prev) => ({
          ...prev,
          mobile,
          mobiletncchecked: true,
          mobiletnctime: new Date().toISOString(),
          stepDone: 3,
        }));
        toast.success("OTP Sent Successfully");
        setIsOtpGenerated(true);
        setIsFormStarted();
        setOtpTimerKey((prev) => prev + 1);
      } else {
        toast.error("Failed to send OTP. Please try again.");
      }
    } catch (error) {
      toast.error("An error occurred while sending OTP.");
    } finally {
      setIsLoading(false);
    }
  };

  const openEditMobileModal = () => {
    setEditMobileValue(mobile || "");
    setEditMobileError("");
    setIsEditMobileModalOpen(true);
  };

  const closeEditMobileModal = () => {
    setIsEditMobileModalOpen(false);
    setEditMobileError("");
  };

  // ✅ handleEditMobileSendOtp added
  const handleEditMobileSendOtp = async () => {
    const nextMobile = String(editMobileValue || "").trim();
    if (!/^\d{10}$/.test(nextMobile)) {
      setEditMobileError("Please enter a valid Mobile Number");
      return;
    }
    try {
      setIsLoading(true);
      const response = await callApi(
        "v1/sms/send-otp",
        "post",
        {
          contact_phone: nextMobile,
          kyc_consent: isConsentChecked,
        },
        "messaging",
      );
      if (response.status === "Success") {
        setMobile(nextMobile);
        setFormData((prev) => ({ ...prev, mobile: nextMobile }));
        setOtp("");
        setIsOtpGenerated(true);
        setOtpTimerKey((prev) => prev + 1);
        closeEditMobileModal();
        toast.success("OTP Sent Successfully");
      } else {
        toast.error("Failed to send OTP. Please try again.");
      }
    } catch (error) {
      toast.error("An error occurred while sending OTP.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleResendOtp = async () => {
    if (!canResendOtp) return;
    try {
      setIsLoading(true);
      const response = await callApi(
        "v1/sms/send-otp",
        "post",
        {
          contact_phone: mobile,
          kyc_consent: isConsentChecked,
          kyc_consent_datetime: new Date().toISOString(),
        },
        "messaging",
      );
      if (response.status === "Success") {
        setUserClickData({
          event_name: `resend-otp-form-for-knightfintech-pre-lead`,
          user_id: mobile || "unknown",
          affiliate_id: affId || "No Aff_id found",
        });
        toast.success("OTP Resent Successfully");
        setOtpTimerKey((prev) => prev + 1);
      } else {
        toast.error("Failed to resend OTP.");
      }
    } catch (error) {
      console.error(error);
      toast.error("An error occurred while resending OTP.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleOtpSubmit = async () => {
    if (otp.length !== 4) {
      toast.error("Please enter a valid 4-digit OTP.");
      return;
    }

    try {
      setIsLoading(true);

      // Step 1: OTP Validate
      const otpResponse = await callApi(
        "v1/sms/validate-otp",
        "post",
        { contact_phone: mobile, otp },
        "messaging",
      );

      if (otpResponse.status === "Success") {
        setUserClickData({
          event_name: `verify-otp-knightfintech-pre-lead`,
          user_id: mobile || "unknown",
          affiliate_id: affId || "No Aff_id found",
          utm_source: utmSource || "",
          utm_medium: utmMedium || "",
        });
        toast.success("OTP Verified Successfully");
        const leadData = await fetchLeadData(otpResponse?.data.token);
        console.log("leadData: ", leadData);

        // Step 2: Login
        dispatch(
          login({
            ...otpResponse.data.customer,
            token: otpResponse.data.token,
          }),
        );
        localStorage.setItem("mobile", mobile);

        // Step 3: Lead fetch/insert
        const leadResponse = await callApi(
          "v1/lead/lead-from-phone",
          "post",
          {
            phone: mobile,
            website_kyc_consent: isTncChecked,
            website_kyc_consent_datetime: new Date().toISOString(),
            kyc_consent: isTncChecked,
            kyc_consent_datetime: new Date().toISOString(),
            utm_source: utmSource,
            otp_page: "knightfintech-pre-lead",
            ip_address: ipAddress,
          },
          "core",
          otpResponse.data.token,
        );

        const fetchedLeadId = leadResponse?.data?.lead?._id;

        if (fetchedLeadId) {
          // Step 4: Campaign API
          try {
            await fetch(
              "https://campaigns.digitmoney.in/api/offercheck/requestjson.php?case=insert_digit_money_data",
              {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                  api_key: "fca6416db1074658d6b6823380d18f04",
                  mobile: mobile,
                  lead_id: fetchedLeadId,
                }),
              },
            );
          } catch (e) {
            console.error("Error in external lead insert:", e);
          }

          // Step 5: ✅ Lender specific bulk push
          if (pre_lender_id === "69cc14e468e241e1283fa592") {
            try {
              const bulkRes = await callApi(
                "v1/lead/bulk-lead-push-by-leadId",
                "post",
                {
                  leads: [{ lead_id: fetchedLeadId }],
                  lender_name: "Knight Fintech",
                  lender_id: "69cc14e468e241e1283fa592",
                },
                "core",
                otpResponse.data.token,
              );
              const bulkData = await bulkRes.json();
              if (bulkData?.status === "Success") {
                toast.success("Lead pushed successfully!");
              } else {
                console.error("Bulk push failed:", bulkData);
              }
            } catch (err) {
              console.error("Bulk push error:", err);
            } finally {
              setCurrentStep(2);
            }
            return;
          }
        }

        // Normal flow
        setCurrentStep(2);
      } else {
        toast.error("Invalid OTP. Please try again.");
      }
    } catch (otpError) {
      console.error("Error occurred while verifying OTP:", otpError);
      //toast.error("An error occurred while verifying OTP. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      {!isOtpGenerated ? (
        // ✅ Mobile input screen
        <div className="lead-capture-container1-kf">
          <input type="hidden" name="utm_campaign" value="" />
          <input type="hidden" name="utm_source" value={utmSource || ""} />
          <input type="hidden" name="utm_medium" value="" />
          <input type="hidden" name="utm_content" value="" />
          <input type="hidden" name="click_id" value="" />
          <input type="hidden" name="aff_id" value={affId || ""} />
          <input type="hidden" name="src" value={source || ""} />

          <FormInputStyle2
            type="text"
            name="mobile"
            isValid={isMobileValid}
            id="mobile"
            minLength="10"
            maxLength="10"
            pattern="[0-9]{10}"
            value={mobile}
            onChange={handleMobileChange}
            required
            label={"Mobile Number"}
            inputMode="numeric"
            errorMessage={"Please enter a valid Mobile Number"}
            className="mobile-kf"
          />
          <div className="checkbox-wrapper-kf">
            <input
              type="checkbox"
              id="consent"
              checked={isConsentChecked}
              onChange={handleConsentChange}
            />
            <label htmlFor="consent" className="consent">
              I have read and agreed to the{" "}
              <a className="anc-font" href="https://digitmoney.in/terms">
                Terms of Use
              </a>{" "}
              and hereby appoint DigitMoney and its{" "}
              <a className="anc-font" href="https://digitmoney.in/lenders">
                Lending Partners
              </a>{" "}
              to receive my credit information from credit bureaus. By
              submitting my details I override my NDNC registration & authorize
              DigitMoney and its{" "}
              <a className="anc-font" href="https://digitmoney.in/lenders">
                Lending Partners
              </a>{" "}
              / representatives to contact me through Call, SMS, Email, WhatsApp
              or any other mode. I also Authorize you to send me new promotional
              offers of financial & non-financial products or services from time
              to time.
              <br />
              <br />
              You will receive OTP on mobile number
            </label>
          </div>

          <FormButtonStyleCheckOffer
            style={{ backgroundColor: "#12F280" }}
            text="Get OTP"
            onClick={handleSendOtp}
            disabled={!isMobileValid || isLoading}
            id="btn-get-otp-landing-v4"
            className="tracking-btn-get-otp-landing-v4-kf"
          />
        </div>
      ) : (
        // ✅ OTP screen - dead block hata diya, sirf yeh render hoga
        <div className="plv16-otp-page-kf">
          <div className="plv16-otp-hero">
            <img
              src="/assets/img/Layer_1 (47).png"
              className="plv16-otp-lock"
              alt="Lock"
            />
            <h1 className="plv16-otp-title">Verify number securely</h1>
            <p className="plv16-otp-subtitle">
              Your details are safe with us
              <img
                src="/assets/img/Layer_1 (48).png"
                className="plv16-otp-info"
                alt="Secure"
              />
            </p>
          </div>

          <div className="plv16-otp-card-kf">
            <div className="plv16-otp-card-title">
              We can help prefill your information
            </div>

            <div className="plv16-otp-card-subtitle">
              Enter OTP sent to{" "}
              <span className="plv16-otp-phone">
                +91-{mobile || "98616XXXXX"}
              </span>{" "}
              <button
                type="button"
                className="plv16-otp-edit"
                onClick={openEditMobileModal}
              >
                Edit
              </button>
            </div>

            <div className="plv16-otp-input-wrap">
              <OTPInput
                value={otp}
                onChange={(val) => setOtp(val)}
                numInputs={4}
                isInputNum={true}
                shouldAutoFocus={true}
                inputStyle="plv16-otp-input"
                containerStyle="plv16-otp-inputs"
                placeholder={"----"}
                renderInput={(props) => <input {...props} />}
              />
            </div>

            <div className="plv16-otp-consent-row">
              <input
                type="checkbox"
                id="plv16-otp-consent"
                checked={isConsentChecked}
                onChange={handleConsentChange}
              />
              <label
                htmlFor="plv16-otp-consent"
                className="plv16-otp-consent-text"
              >
                I have read and agreed to the{" "}
                <a href="https://digitmoney.in/terms">Terms of Use</a> and
                hereby appoint DigitMoney and its{" "}
                <a href="https://digitmoney.in/lenders">Lending Partners</a> to
                receive my credit information from credit bureaus. By submitting
                my details I override my NDNC registration and authorize
                DigitMoney and its Lending Partners to contact me.
              </label>
            </div>
          </div>

          <div className="plv16-otp-footer">
            <div className="plv16-otp-resend">
              {canResendOtp ? (
                <button
                  type="button"
                  className="plv16-otp-resend-link"
                  onClick={handleResendOtp}
                  disabled={isLoading}
                >
                  Resend OTP
                </button>
              ) : (
                <>
                  Resend OTP in <span>{formatResendTime(resendCounter)}</span>
                </>
              )}
            </div>

            <button
              type="button"
              className="plv16-otp-btn"
              onClick={handleOtpSubmit}
              disabled={otp.length !== 4 || isLoading}
              id="btn-verify-otp-personal-details-v9"
            >
              {isLoading ? "Processing..." : "Verify OTP"}
            </button>
          </div>

          {/* ✅ Edit Mobile Modal - handleEditMobileSendOtp fix */}
          {isEditMobileModalOpen ? (
            <div
              className="plv16-otp-modal-overlay"
              role="dialog"
              aria-modal="true"
              onClick={closeEditMobileModal}
            >
              <div
                className="plv16-otp-modal"
                onClick={(e) => e.stopPropagation()}
              >
                <div className="plv16-otp-modal-header">
                  <button
                    type="button"
                    className="plv16-otp-modal-close"
                    onClick={closeEditMobileModal}
                    aria-label="Close"
                  >
                    ×
                  </button>
                </div>
                <div className="plv16-otp-modal-title">Edit Mobile Number</div>
                <div className="plv16-otp-modal-subtitle">
                  We'll send a new OTP to this number.
                </div>

                <div className="plv16-otp-modal-body">
                  <input
                    type="tel"
                    inputMode="numeric"
                    placeholder="Enter New Mobile Number"
                    className="plv16-otp-modal-input"
                    value={editMobileValue}
                    onChange={(e) => {
                      const next = e.target.value
                        .replace(/\D/g, "")
                        .slice(0, 10);
                      setEditMobileValue(next);
                      setEditMobileError("");
                    }}
                  />
                  {editMobileError ? (
                    <div className="plv16-otp-modal-error">
                      {editMobileError}
                    </div>
                  ) : null}

                  {/* ✅ handleEditMobileSendOtp - sahi function */}
                  <button
                    type="button"
                    className="plv16-otp-modal-btn"
                    onClick={handleEditMobileSendOtp}
                    disabled={isLoading}
                  >
                    {isLoading ? "Processing..." : "Send OTP"}
                  </button>

                  <div className="plv16-otp-modal-footnote">
                    Make sure this number is active to receive the OTP.
                  </div>
                </div>
              </div>
            </div>
          ) : null}
        </div>
      )}
    </>
  );
};

export default MobileOtpPage;